import React, { useCallback, useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import IconButton from "@mui/material/IconButton";
import Tooltip from "@mui/material/Tooltip";
import Badge from "@mui/material/Badge";
import EmailRoundedIcon from "@mui/icons-material/EmailRounded";
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "../../../redux/store";
import { useUser } from "../../../context/UserContext";
import useApi from "../../../hooks/useApi";
import { getInternalMessagesUnreadCount } from "../../../services/messageService";
import { increment, setCount } from "../../../redux/messageCountSlice";
import { GLOBALSETTINGS, Messages } from "../../../data/constants";
import { playAlertSound } from "../../../utils/commonHelper";
import { useSignalR } from "../../../hooks/useSignalR";
import { INTERNALMESSAGES } from "../../../constants/messages";
import "./Messages.scss";
import { useSignalRConnections } from "../../../context/SignalRProvider";

const MessagesIcon: React.FC = () => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const messageCount = useSelector((state: RootState) => state.messageCount.count);
  const [shouldBlink, setShouldBlink] = useState(false);
  const { userId } = useUser();
  const { executeApi } = useApi();

  const messageAlertHandler = useCallback(
    (toUser: number) => {
      if (toUser === userId) {
        dispatch(increment());
        playAlertSound();
        setShouldBlink(true);
        setTimeout(() => setShouldBlink(false), GLOBALSETTINGS.BLINK_TIME);
      }
    },
    [userId, dispatch]
  );
  const { notificationConnection } = useSignalRConnections();
  useSignalR(notificationConnection, "MessageAlert", messageAlertHandler);

  const fetchNotificationsCount = useCallback(async () => {
    if (userId && userId > 0) {
      const result = await executeApi<void, number>(getInternalMessagesUnreadCount, null);
      if (result) {
        dispatch(setCount(result));
      }
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [userId]);

  useEffect(() => {
    fetchNotificationsCount();
  }, [fetchNotificationsCount]);

  return (
    <IconButton onClick={() => navigate("/messages")} sx={{ color: "white", p: 0.5 }}>
      <Tooltip title={INTERNALMESSAGES.MESSAGES}>
        <Badge
          badgeContent={messageCount}
          sx={{
            "& .MuiBadge-badge": {
              backgroundColor: "red",
              color: "white",
            },
          }}
          max={Messages.MAXIMUMCOUNT_LIMIT}
        >
          <EmailRoundedIcon id="internalMessages" className={shouldBlink ? "blink" : ""} />
        </Badge>
      </Tooltip>
    </IconButton>
  );
};

export default MessagesIcon;
